// Cấu hình giải thưởng cho 3 miền
export const MB_REWARDS = [
  {
    id: "MB_GIAI_DB",
    order: 0,
    value: 2000000000,
    lastDigits: 5,
    name: "Giải ĐB",
  },
  {
    id: "MB_GIAI_1",
    order: 1,
    value: 30000000,
    lastDigits: 5,
    name: "Giải Nhất",
  },
  {
    id: "MB_GIAI_2",
    order: 2,
    value: 15000000,
    lastDigits: 5,
    name: "Giải Nhì",
  },
  {
    id: "MB_GIAI_3",
    order: 3,
    value: 10000000,
    lastDigits: 5,
    name: "Giải Ba",
  },
  { id: "MB_GIAI_4", order: 4, value: 3000000, lastDigits: 4, name: "Giải Tư" },
  {
    id: "MB_GIAI_5",
    order: 5,
    value: 1000000,
    lastDigits: 4,
    name: "Giải Năm",
  },
  { id: "MB_GIAI_6", order: 6, value: 400000, lastDigits: 3, name: "Giải Sáu" },
  { id: "MB_GIAI_7", order: 7, value: 200000, lastDigits: 2, name: "Giải Bảy" },
  {
    id: "MB_GIAI_PHU_DB",
    order: 8,
    value: 50000000,
    lastDigits: 5,
    name: "Giải Phụ ĐB",
  },
  {
    id: "MB_GIAI_KK",
    order: 9,
    value: 50000000,
    lastDigits: 5,
    name: "Giải KK",
  },
];

export const MN_REWARDS = [
  {
    id: "MN_GIAI_DB",
    order: 0,
    value: 2000000000,
    lastDigits: 6,
    name: "Giải ĐB",
  },
  {
    id: "MN_GIAI_1",
    order: 1,
    value: 30000000,
    lastDigits: 5,
    name: "Giải Nhất",
  },
  {
    id: "MN_GIAI_2",
    order: 2,
    value: 15000000,
    lastDigits: 5,
    name: "Giải Nhì",
  },
  {
    id: "MN_GIAI_3",
    order: 3,
    value: 10000000,
    lastDigits: 5,
    name: "Giải Ba",
  },
  { id: "MN_GIAI_4", order: 4, value: 3000000, lastDigits: 5, name: "Giải Tư" },
  {
    id: "MN_GIAI_5",
    order: 5,
    value: 1000000,
    lastDigits: 4,
    name: "Giải Năm",
  },
  { id: "MN_GIAI_6", order: 6, value: 400000, lastDigits: 4, name: "Giải Sáu" },
  { id: "MN_GIAI_7", order: 7, value: 200000, lastDigits: 3, name: "Giải Bảy" },
  { id: "MN_GIAI_8", order: 8, value: 100000, lastDigits: 2, name: "Giải Tám" },
  {
    id: "MN_GIAI_PHU_DB",
    order: 9,
    value: 50000000,
    lastDigits: 6,
    name: "Giải Phụ ĐB",
  },
  {
    id: "MN_GIAI_KK",
    order: 10,
    value: 50000000,
    lastDigits: 6,
    name: "Giải KK",
  },
];

export const MT_REWARDS = [
  {
    id: "MT_GIAI_DB",
    order: 0,
    value: 2000000000,
    lastDigits: 6,
    name: "Giải ĐB",
  },
  {
    id: "MT_GIAI_1",
    order: 1,
    value: 30000000,
    lastDigits: 5,
    name: "Giải Nhất",
  },
  {
    id: "MT_GIAI_2",
    order: 2,
    value: 15000000,
    lastDigits: 5,
    name: "Giải Nhì",
  },
  {
    id: "MT_GIAI_3",
    order: 3,
    value: 10000000,
    lastDigits: 5,
    name: "Giải Ba",
  },
  { id: "MT_GIAI_4", order: 4, value: 3000000, lastDigits: 5, name: "Giải Tư" },
  {
    id: "MT_GIAI_5",
    order: 5,
    value: 1000000,
    lastDigits: 4,
    name: "Giải Năm",
  },
  { id: "MT_GIAI_6", order: 6, value: 400000, lastDigits: 4, name: "Giải Sáu" },
  { id: "MT_GIAI_7", order: 7, value: 200000, lastDigits: 3, name: "Giải Bảy" },
  { id: "MT_GIAI_8", order: 8, value: 100000, lastDigits: 2, name: "Giải Tám" },
  {
    id: "MT_GIAI_PHU_DB",
    order: 9,
    value: 50000000,
    lastDigits: 6,
    name: "Giải Phụ ĐB",
  },
  {
    id: "MT_GIAI_KK",
    order: 10,
    value: 50000000,
    lastDigits: 6,
    name: "Giải KK",
  },
];

export const CLASSIC_REWARDS_BY_REGION = {
  MB: MB_REWARDS,
  MN: MN_REWARDS,
  MT: MT_REWARDS,
};

/**
 * Lấy danh sách giải thưởng theo miền
 * @param {string} region - Miền (MB, MN, MT)
 * @returns {Array} Danh sách giải thưởng
 */
export function getClassicRewardsByRegion(region) {
  return CLASSIC_REWARDS_BY_REGION[region] || MB_REWARDS;
}

/**
 * Parse rewardNumbers từ JSON string và trả về danh sách giải thưởng đã trúng
 * @param {string} rewardNumbersJson - JSON string chứa thông tin giải thưởng, ví dụ: '{"MT_GIAI_7":1,"MT_GIAI_8":1}'
 * @param {string} region - Miền (MB, MN, MT)
 * @returns {Array} Danh sách giải thưởng đã trúng với format: [{name: "Giải Bảy", count: 1}, ...]
 */
export function parseRewardNumbers(rewardNumbersJson, region) {
  if (!rewardNumbersJson || rewardNumbersJson === "") {
    return [];
  }

  try {
    const rewardNumbers = JSON.parse(rewardNumbersJson);
    const rewards = getClassicRewardsByRegion(region);
    const result = [];

    // Sắp xếp theo thứ tự giải (từ cao xuống thấp)
    Object.entries(rewardNumbers).forEach(([rewardId, count]) => {
      const reward = rewards.find((r) => r.id === rewardId);
      if (reward && count > 0) {
        result.push({
          id: rewardId,
          name: reward.name,
          count: count,
          order: reward.order,
        });
      }
    });

    // Sắp xếp theo thứ tự giải
    result.sort((a, b) => a.order - b.order);

    return result;
  } catch (error) {
    console.error("Error parsing rewardNumbers:", error);
    return [];
  }
}

/**
 * Format danh sách giải thưởng thành chuỗi hiển thị
 * @param {Array} rewards - Danh sách giải thưởng từ parseRewardNumbers
 * @returns {string} Chuỗi hiển thị, ví dụ: "Giải Bảy (1), Giải Tám (1)"
 */
export function formatRewardsList(rewards) {
  if (!rewards || rewards.length === 0) {
    return "-";
  }

  return rewards.map((r) => `${r.name} (${r.count})`).join(", ");
}

/**
 * Lấy region từ channel
 * @param {Object} channel - Channel object
 * @returns {string} Region (MB, MN, MT)
 */
export function getRegionFromChannel(channel) {
  if (!channel) return "MB";
  return channel.region || "MB";
}
